module.exports = __webpack_public_path__ + "img/banner-horses.4ed4ed8b.jpg";